import React from 'react';
import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

const TESTS_ICON_GRADIENT = 'navigationTestsGradient';

const TestsIconSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SPath d="M18 1.80371C19.6569 1.80371 21 3.14686 21 4.80371V18.8037C21 20.4606 19.6569 21.8037 18 21.8037H6C4.34315 21.8037 3 20.4606 3 18.8037V4.80371C3 3.14686 4.34315 1.80371 6 1.80371H18ZM7 17.0537C6.58579 17.0537 6.25 17.3895 6.25 17.8037C6.25 18.2179 6.58579 18.5537 7 18.5537H12C12.4142 18.5537 12.75 18.2179 12.75 17.8037C12.75 17.3895 12.4142 17.0537 12 17.0537H7ZM7 14.0537C6.58579 14.0537 6.25 14.3895 6.25 14.8037C6.25 15.2179 6.58579 15.5537 7 15.5537H17C17.4142 15.5537 17.75 15.2179 17.75 14.8037C17.75 14.3895 17.4142 14.0537 17 14.0537H7ZM9 6.05371C7.48122 6.05371 6.25 7.28493 6.25 8.80371V11.8037C6.25 12.2179 6.58579 12.5537 7 12.5537C7.41421 12.5537 7.75 12.2179 7.75 11.8037V10.5537H10.25V11.8037C10.25 12.2179 10.5858 12.5537 11 12.5537C11.4142 12.5537 11.75 12.2179 11.75 11.8037V8.80371C11.75 7.28493 10.5188 6.05371 9 6.05371ZM15.5 5.05371C15.0858 5.05371 14.75 5.3895 14.75 5.80371V6.55371H14C13.5858 6.55371 13.25 6.8895 13.25 7.30371C13.25 7.71792 13.5858 8.05371 14 8.05371H14.75V8.80371C14.75 9.21792 15.0858 9.55371 15.5 9.55371C15.9142 9.55371 16.25 9.21792 16.25 8.80371V8.05371H17C17.4142 8.05371 17.75 7.71792 17.75 7.30371C17.75 6.8895 17.4142 6.55371 17 6.55371H16.25V5.80371C16.25 5.3895 15.9142 5.05371 15.5 5.05371ZM9 7.55371C9.69036 7.55371 10.25 8.11336 10.25 8.80371V9.05371H7.75V8.80371C7.75 8.11336 8.30964 7.55371 9 7.55371Z" />
      <defs>
        <linearGradient
          id={TESTS_ICON_GRADIENT}
          x1="17.3686"
          y1="24.8658"
          x2="3.31051"
          y2="1.45904"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EB0335" />
          <stop offset="1" stopColor="#FFB46E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TestsIconSvg;

const SPath = styled.path`
  fill: #a5aac5;

  ${onLightTheme`
    fill: rgb(var(--ln-content));
  `}

  .active && {
    fill: url(#${TESTS_ICON_GRADIENT});
  }
`;
